// Field type options for step 4 response fields
export const FIELD_TYPE_OPTIONS = [
  {
    value: 'compliance_status',
    label: 'Compliance Status',
    tooltip: 'Result of the assessment.\nNo exceptions noted\nExceptions noted',
  },
  {
    value: 'test_results',
    label: 'Test Results',
    tooltip:
      'Details of the tests performed and the results including any exceptions identified.',
  },
  {
    value: 'gaps',
    label: 'Gaps',
    tooltip:
      'Observed deficiencies or missing elements in the design or implementation of the control.',
  },
  {
    value: 'recommendations',
    label: 'Recommendations',
    tooltip:
      'Suggestions generated by Zania to remediate identified gaps and improve the control.',
  },
  {
    value: 'improvement_opportunities',
    label: 'Improvement Opportunities',
    tooltip:
      'Additional recommendations for enhancing the control, even if no gap was formally noted.',
  },
  {
    value: 'observations',
    label: 'Observations',
    tooltip:
      "Notable findings or context from testing that support understanding of the control but aren't formal gaps.",
  },
  {
    value: 'references',
    label: 'References',
    tooltip:
      'References to supporting evidence or documentation used to assess the control.',
  },
];

// Helper function to check if a field is a valid field type
export const isValidFieldType = (fieldName: string): boolean => {
  return FIELD_TYPE_OPTIONS.some((option) => option.label === fieldName);
};

// Helper function to get field type labels
export const getFieldTypeLabels = (): string[] => {
  return FIELD_TYPE_OPTIONS.map((option) => option.label);
};
